export default __webpack_public_path__ + "static/media/Vero.PrivacyPolicy.42606d21.docx";